<template>
  <!-- 日期选择器 -->
  <el-date-picker
    ref="date"
    v-model="val"
    :size="elSize"
    :disabled="elDisabled"
    :style="{
      width: elWidth
    }"
    :popper-class="customPopperClass"
    :type="type"
    :placeholder="_locale(placeholder)"
    :clearable="clearable"
    :editable="editable"
    :format="format"
    :value-format="valueFormat"
    :picker-options="pickerOptions"
    :firstDayOfWeek="firstDayOfWeek"
    :validate-event="validateEvent"
    :start-placeholder="_locale(startPlaceholder)"
    :end-placeholder="_locale(endPlaceholder)"
    :range-separator="_locale(rangeSeparator)"
    :default-time="defaultTime"
    :default-value="defaultValue"
    :unlink-panels="unlinkPanels"
    :readonly="readonly"
    :align="align"
    :name="name"
    :prefix-icon="prefixIcon"
    :suffix-icon="suffixIcon"
    :icon-float="iconFloat"
    :showTooltip="showTooltip"
    :clear-icon="clearIcon"
    :pick-today="pickToday"
    :init-left-prev-month="initLeftPrevMonth"
    :auto-disabled-date="autoDisabledDate"
    @blur="handleBlur"
    @focus="handleFocus"
    @panel-change="handlePanelChange"
  ></el-date-picker>
</template>
<script>
import { strToDate } from '../../utils/date.js'
import formMixin from './formMixin'
export default {
  name: 'SuiDate',
  mixins: [formMixin],
  inject: {
    SuiForm: {
      default: null
    }
  },
  props: {
    type: {
      type: String,
      default: 'date'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    rangeSeparator: {
      type: String,
      default: '-'
    },
    endPlaceholder: {
      type: String,
      default: '$t[sui.form.date.end]'
    },
    startPlaceholder: {
      type: String,
      default: '$t[sui.form.date.start]'
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    },
    firstDayOfWeek: {
      default: 7,
      type: Number,
      validator: (val) => val >= 1 && val <= 7
    },
    valueFormat: {
      type: String,
      default: 'yyyyMMdd'
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    defaultTime: {
      type: Array,
      default: null
    },
    defaultValue: {
      type: String,
      default: undefined
    },
    editable: {
      type: Boolean,
      default: true
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    unlinkPanels: {
      type: Boolean
    },
    readonly: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'left'
    },
    name: {
      type: String
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close'
    },
    shortcutsPlacement: {
      type: String,
      default: 'left'
    },
    popperClass: {
      type: String,
      default: ''
    },
    iconFloat: {
      type: String,
      default: 'left'
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    pickToday: {
      type: Boolean,
      default: false
    },
    // 判断value是否是空置，返回true表示空值，返回false表示非空值
    checkEmptyValue: Function,
    initLeftPrevMonth: {
      type: Boolean,
      default: false
    },
    autoDisabledDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    val: {
      get() {
        let _value = this.prop && this.SuiForm ? this.SuiForm.model[this.prop] : this.value
        if (typeof this.checkEmptyValue === 'function') {
          _value = this.checkEmptyValue(_value) ? '' : _value
        }
        return _value instanceof Array ? _value.map((item) => item + '') : typeof _value === 'number' ? _value + '' : _value
      },
      set(val) {
        if (this.prop && this.SuiForm) {
          this.SuiForm.model[this.prop] = val
        } else {
          this.$emit('input', val)
        }
      }
    },
    customPopperClass() {
      return (
        `sui-date-picker ${this.popperClass}` +
        (this.shortcutsPlacement === 'top' ? ' shortcuts-panel shortcuts-panel__top ' : '') +
        (this.shortcutsPlacement === 'bottom' ? ' shortcuts-panel shortcuts-panel__bottom' : '')
      )
    }
  },
  created() {
    this.repairPickerOptions()
  },
  mounted() {},
  methods: {
    handlePanelChange(date) {
      this.$emit('panel-change', date)
    },
    // 构造date的最大最小值
    repairPickerOptions() {
      if (this.type === 'date') {
        if (!this.pickerOptions.disabledDate) {
          this.pickerOptions.disabledDate = (time) => {
            var flag = false
            if (this.max) {
              flag = time.getTime() > strToDate(this.max).getTime()
            }
            if (!flag && this.min) {
              flag = time.getTime() < strToDate(this.min).getTime()
            }
            return flag
          }
        }
      }
    },
    focus() {
      return this.$refs.date.focus()
    }
  }
}
</script>
<style lang="scss">
.shortcuts-panel {
  .el-picker-panel *[slot='sidebar'],
  .el-picker-panel__sidebar {
    position: relative;
    border: none;
    width: 100%;
    & + .el-picker-panel__body {
      margin-left: 0;
    }
  }
  &.el-date-picker.has-sidebar {
    width: auto;
  }
  .el-picker-panel__shortcut {
    width: auto;
    /* display: inline-block; */
    float: right;
  }
  &__top {
    .el-picker-panel *[slot='sidebar'],
    .el-picker-panel__sidebar {
      border-bottom: 1px solid #e4e4e4;
    }
  }
}
.sui-date-picker {
  &.el-date-picker {
    width: 302px;
    .el-date-picker__header {
      margin: 5px;
    }
    .el-picker-panel__content {
      margin: 5px;
    }
  }
  &.el-date-range-picker {
    .el-date-range-picker__content {
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/form/SuiDate.vue